import React from "react";
import {
  Card,
  Input,
  Select,
  Typography,
  Alert,
  Row,
  Col,
  Switch,
} from "antd";
import type { LandingMacro } from "../types/api";

export const MacroList: React.FC<{
  value: LandingMacro[];
  onChange: (next: LandingMacro[]) => void;
  disabled?: boolean;
}> = ({ value, onChange, disabled }) => {
  const ensure = (arr?: LandingMacro[]) => (Array.isArray(arr) ? arr : []);
  const macros = ensure(value);

  const update = (idx: number, patch: Partial<LandingMacro>) => {
    const next = macros.slice();
    next[idx] = { ...next[idx], ...patch };
    onChange(next);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 12,
        }}
      >
        <Typography.Text strong>Макроси</Typography.Text>
      </div>

      {macros.length === 0 ? (
        <Alert type="warning" showIcon message="Немає макросів" />
      ) : (
        <div style={{ maxHeight: 400, overflowY: "auto" }}>
          {macros.map((m, idx) => (
            <Card
              key={m.id || idx}
              size="small"
              style={{ marginBottom: 12 }}
              title={`Макрос #${idx + 1}: ${m.label || m.name || "—"}`}
            >
              <Row gutter={[12, 12]}>
                <Col span={12}>
                  <label>
                    <strong>Назва змінної:</strong>
                  </label>
                  <Input
                    disabled
                    readOnly
                    value={m.name}
                    onChange={(e) => update(idx, { name: e.target.value })}
                    placeholder="COMPANY_NAME"
                    style={{ marginTop: 4 }}
                  />
                </Col>
                <Col span={12}>
                  <label>
                    <strong>Відображувана назва:</strong>
                  </label>
                  <Input
                    disabled={disabled}
                    value={m.label}
                    onChange={(e) => update(idx, { label: e.target.value })}
                    placeholder="Назва компанії"
                    style={{ marginTop: 4 }}
                  />
                </Col>

                <Col span={8}>
                  <label>
                    <strong>Тип:</strong>
                  </label>
                  <Select
                    disabled={disabled}
                    value={m.type || "string"}
                    onChange={(v) => update(idx, { type: v })}
                    style={{ width: "100%", marginTop: 4 }}
                    options={[
                      { value: "string", label: "Текст" },
                      { value: "file", label: "Файл" },
                    ]}
                  />
                </Col>

                <Col span={8}>
                  <label>
                    <strong>Обов'язковий:</strong>
                  </label>
                  <div style={{ marginTop: 8 }}>
                    <Switch
                      disabled={disabled}
                      checked={!!m.required}
                      onChange={(checked) => update(idx, { required: checked })}
                    />
                  </div>
                </Col>

                <Col span={8}>
                  {m.type === "string" && (
                    <>
                      <label>
                        <strong>Значення за замовчуванням:</strong>
                      </label>
                      <Input
                        disabled={disabled}
                        value={m.defaultValue}
                        onChange={(e) =>
                          update(idx, { defaultValue: e.target.value })
                        }
                        placeholder="Стандартне значення"
                        style={{ marginTop: 4 }}
                      />
                    </>
                  )}
                </Col>

                <Col span={24}>
                  <label>
                    <strong>Опис:</strong>
                  </label>
                  <Input.TextArea
                    disabled={disabled}
                    value={m.description}
                    onChange={(e) =>
                      update(idx, { description: e.target.value })
                    }
                    rows={2}
                    placeholder="Опис призначення цього макросу"
                    style={{ marginTop: 4 }}
                  />
                </Col>
              </Row>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};
